// extracted by mini-css-extract-plugin
export var black = "_35-6";
export var brand = "_35-1";
export var ddefault = "_35-0";
export var error = "_35-3";
export var gray = "_35-2";
export var highContrast = "_35-8";
export var outline = "_35-7";
export var success = "_35-5";
export var warning = "_35-4";